import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "./Logo";
import { useLanguage } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-black border-t border-white/5" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo withText size={36} />
            <p className="mt-5 text-sm text-zinc-500 max-w-sm leading-relaxed">
              {t.footer.tagline}
            </p>
            <p className="mt-2 text-xs text-zinc-600 font-mono">
              {t.footer.built}
            </p>
            <a
              href="mailto:contact@smaktech.fr"
              data-testid="footer-email"
              className="mt-6 inline-flex items-center gap-2 text-sm text-zinc-300 hover:smk-gradient-text transition"
            >
              <Mail size={14} className="text-[#00d4ff]" />
              contact@smaktech.fr
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="smk-overline mb-4">{t.footer.nav}</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-zinc-400 hover:text-white" data-testid="footer-home">{t.nav.home}</Link></li>
              <li><Link to="/services" className="text-zinc-400 hover:text-white" data-testid="footer-services">{t.nav.services}</Link></li>
              <li><Link to="/offers" className="text-zinc-400 hover:text-white" data-testid="footer-offers">{t.nav.offers}</Link></li>
              <li><Link to="/tools" className="text-zinc-400 hover:text-white" data-testid="footer-tools">{t.nav.tools}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="smk-overline mb-4">{t.footer.services}</p>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li>Conseil & Architecture Cloud</li>
              <li>Supervision & Exploitation</li>
              <li>
                {t.offers.tiers.non.name} / {t.offers.tiers.hybride.name} / {t.offers.tiers.full.name}
              </li>
              <li>Outils collaboratifs (Nextcloud, Collabora)</li>
              <li>DevOps & Sécurité</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-zinc-600 font-mono">
            © {year} SMAKTECH — {t.footer.rights}
          </p>
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-[#00ffb3] smk-pulse-dot"></span>
            <span className="text-xs text-zinc-500 font-mono">Systems operational</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
